import { z } from 'zod';
import { defineEndpoint } from '../define';
import { ReleaseDetailSchema } from './shapes';

/** Re-pin the draft's commit SHA from its git ref (draft only, explicit action). */
export const refreshReleaseRef = defineEndpoint({
  method: 'POST',
  path: '/v1/releases/:releaseId/refresh-ref',
  params: z.object({ releaseId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: ReleaseDetailSchema }),
});
